// extracted by mini-css-extract-plugin
export default {"modal":"historyTransactionModal_modal__JS8n0","closeBtn":"historyTransactionModal_closeBtn__JKZ18","popup":"historyTransactionModal_popup__RljRV"};